/**
 * @generated SignedSource<<46866042467d4d2da8de41704230f109>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type MultipleChoiceElementPart_SubmittedAnswersQuery$variables = {
  submissionId: string;
};
export type MultipleChoiceElementPart_SubmittedAnswersQuery$data = {
  readonly LearnV2: {
    readonly GetSubmittedAnswers: ReadonlyArray<{
      readonly answers: ReadonlyArray<string>;
      readonly question: string;
    }>;
  };
};
export type MultipleChoiceElementPart_SubmittedAnswersQuery = {
  response: MultipleChoiceElementPart_SubmittedAnswersQuery$data;
  variables: MultipleChoiceElementPart_SubmittedAnswersQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "submissionId"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "LearnV2Queries",
    "kind": "LinkedField",
    "name": "LearnV2",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "submissionId",
            "variableName": "submissionId"
          }
        ],
        "concreteType": "MultipleChoiceDecision",
        "kind": "LinkedField",
        "name": "GetSubmittedAnswers",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "question",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "answers",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MultipleChoiceElementPart_SubmittedAnswersQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MultipleChoiceElementPart_SubmittedAnswersQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2bde8dfd074473e2fc3c1458ffcbcfa0",
    "id": null,
    "metadata": {},
    "name": "MultipleChoiceElementPart_SubmittedAnswersQuery",
    "operationKind": "query",
    "text": "query MultipleChoiceElementPart_SubmittedAnswersQuery(\n  $submissionId: ID!\n) {\n  LearnV2 {\n    GetSubmittedAnswers(submissionId: $submissionId) {\n      question\n      answers\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2ca37d8a0fa098eddc60793a8d2d44db";

export default node;
